module.exports = __webpack_public_path__ + "img/promotion_completion_rate.28bfe80a.png";